import { TrelloPowerUpContext } from '@powerupsclub/trello';
import { Member } from '@powerupsclub/trello/dist/types';
import React, { useContext } from 'react';
import Avatar from '@atlaskit/avatar';

export const VotersPopup: React.FC = () => {
  const { trelloIframe } = useContext(TrelloPowerUpContext);

  const poll = trelloIframe.arg('poll');
  const option = trelloIframe.arg('option');

  const voters = option.idMemberVotes.map(
    (idMember: string) => poll.membersMap[idMember]
  );

  return (
    <div>
      {voters.map((voter: Member) => (
        <div
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            marginBottom: '8px',
          }}
        >
          <Avatar src={voter.avatar} name={voter.fullName} />
          <div>{voter.fullName}</div>
        </div>
      ))}
    </div>
  );
};
